import { render, staticRenderFns } from "./largeEnergy.vue?vue&type=template&id=6ae3e9c0&scoped=true"
import script from "./largeEnergy.vue?vue&type=script&lang=js"
export * from "./largeEnergy.vue?vue&type=script&lang=js"
import style0 from "./largeEnergy.vue?vue&type=style&index=0&id=6ae3e9c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae3e9c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae3e9c0')) {
      api.createRecord('6ae3e9c0', component.options)
    } else {
      api.reload('6ae3e9c0', component.options)
    }
    module.hot.accept("./largeEnergy.vue?vue&type=template&id=6ae3e9c0&scoped=true", function () {
      api.rerender('6ae3e9c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/largeEnergy.vue"
export default component.exports